const routesToServiceData = (routes) => {
  const servicesRoute = routes.find((r) => r.name === "Services");
  if (!servicesRoute?.collapse) return [];

  return servicesRoute.collapse
    .filter((group) => group.collapse?.length > 0)
    .map((group) => ({
      title: group.name,
      description: group.description || "",
      items: group.collapse
        .filter((item) => item.route)
        .map((item) => ({
          name: item.name,
          description: item.description || "",
          route: item.route,
        })),
    }));
};

export default routesToServiceData;
